export default function linkifyHtml(content = '') {
  const words = content.split(' ');
  const urlRegex = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;

  let resultHtml = '';
  
  for (const word of words) {
    if (urlRegex.test(word)) {
      resultHtml += ` <a style="color:#173db0;" href="${word}" target="_blank">${word}</a>`;
    } else {
      resultHtml += ` ${word}`;
    }
  }

  return resultHtml;
}



// WEBPACK FOOTER //
// ./src/linkifyHtml.js